// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  width: 100%;
  background-color: #FFFFFF;
  /*.range-knob-handle {
      background-image: url("assets/icon/hexagon_knob_small.png");
  }*/
}
:host ion-range {
  --bar-background: var(--ion-color-secondary);
  --bar-background-active: var(--ion-color-secondary);
  --bar-height: 4px;
  --bar-border-radius: 1px;
  --knob-background: var(--ion-color-primary);
  --knob-size: 20px;
  margin-top: -15px;
}
:host ion-range::part(tick) {
  background: var(--ion-color-secondary);
}
:host ion-range::part(tick-active) {
  background: var(--ion-color-secondary);
}
:host div.value {
  font-weight: bold;
  vertical-align: bottom;
  margin-top: 3px;
  font-size: 0.8rem;
}
:host .slidervalue {
  vertical-align: middle;
}
:host .sliderrow {
  height: 30px;
}
:host .range-md .range-knob {
  background: #fff;
  border: 3px solid var(--ion-color-primary);
  width: 25px;
  height: 25px;
  top: 0px;
}
:host .range-md .range-knob-min.range-knob-min .range-knob {
  background: #fff;
  border: 3px solid var(--ion-color-primary);
}
:host .item-md.item-block .item-inner {
  border: none;
}
:host .item-ios.item-block .item-inner {
  border: none;
}
:host .range-md {
  padding-right: 20px;
}
:host img {
  width: 25px;
  height: 25px;
}
:host .col {
  padding: 0px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
